import React from "react";

import {
  STYLES,
  EMPTY_ARRAY_LENGTH,
  SINGLE_ARRAY_LENGTH,
  inboxReduxConstants,
} from "../../../constants";
import BootstrapSpinner from "./bootstrapSpinner";
import OrderDetailsComponent from "./orderDetailsComponent";
import SendMessageComponent from "./sendMessageComponent";
import ReceiveMessageComponent from "./receiveMessageComponent";
import FilesPreviewComponent from "./filesPreviewComponent";
import InputFieldsComponent from "./inputFieldsComponent";

/**
 * Main chat panel: order details, message thread, file preview, and composer.
 */
const ConversationPanel = ({
  user,
  files,
  spinner,
  showChat,
  setFiles,
  isSending,
  setMessage,
  sendMessage,
  selectedChat,
  chatAreaRef,
  orderDetails,
  inputMessage,
  localCustomerId,
  isSuperAdmin,
  fileUploaderRef,
  inputFieldRef,
  showEmojiPicker,
  isAIReplyActive,
  handleFileChange,
  handleEmojiClick,
  setShowEmojiPicker,
  generateAiResponse,
  customerPreviewSurvey,
  selectedConversation,
  handleInputMessageChange,
  isConversationSelected,
  isAIGenerationButtonVisible,
}) => {
  if (spinner(inboxReduxConstants.GET_CONVERSATION_MESSAGES)) {
    return (
      <div className="h-100 d-flex align-items-center justify-content-center">
        <BootstrapSpinner />
      </div>
    );
  }

  if (showChat) {
    return (
      <div className="input-and-chat h-100">
        <div
          className="overflow-y-auto custome-sidebar mb-1 h-100 chat"
          ref={chatAreaRef}
        >
          <OrderDetailsComponent
            spinner={spinner}
            orderDetails={orderDetails}
            customerPreviewSurvey={customerPreviewSurvey}
          />
          {isConversationSelected &&
            selectedChat?.map((messageItem) =>
              messageItem.inReplyTo ? (
                <ReceiveMessageComponent
                  message={messageItem}
                  key={messageItem.id}
                  selectedConversation={selectedConversation}
                />
              ) : (
                <SendMessageComponent
                  user={user}
                  key={messageItem.id}
                  message={messageItem}
                  selectedConversation={selectedConversation}
                />
              ),
            )}
        </div>
        <div
          className={`position-relative ${
            Object.keys(selectedConversation || {}).length ===
              EMPTY_ARRAY_LENGTH && STYLES.D_NONE
          }`}
        >
          {files.length > EMPTY_ARRAY_LENGTH && (
            <div>
              {files.length > SINGLE_ARRAY_LENGTH && (
                <button
                  className={`small border-0 bg-transparent ${STYLES.TEXT_DANGER} mx-3`}
                  onClick={() => setFiles([])}
                >
                  Remove all
                </button>
              )}
              <FilesPreviewComponent
                files={files}
                setFiles={setFiles}
                ref={fileUploaderRef}
              />
            </div>
          )}
          <div className="input-message">
            <InputFieldsComponent
              user={user}
              files={files}
              message={inputMessage}
              spinner={spinner}
              isSending={isSending}
              setMessage={setMessage}
              sendMessage={sendMessage}
              isSuperAdmin={isSuperAdmin}
              isAIReplyActive={isAIReplyActive}
              showEmojiPicker={showEmojiPicker}
              handleFileChange={handleFileChange}
              handleEmojiClick={handleEmojiClick}
              setShowEmojiPicker={setShowEmojiPicker}
              generateAiResponse={generateAiResponse}
              ref={{ inputFieldRef, fileUploaderRef }}
              handleMessageChange={handleInputMessageChange}
              selectedConversation={selectedConversation}
              isAIGenerationButtonVisible={isAIGenerationButtonVisible}
            />
          </div>
        </div>
      </div>
    );
  }

  if (localCustomerId) {
    return (
      <div className="h-100 d-flex justify-content-center align-items-center">
        Loading your conversation, please wait...
      </div>
    );
  }

  return (
    <div className="h-100 d-flex justify-content-center align-items-center">
      Select a customer from the list on the lefthand side to start a
      conversation
    </div>
  );
};

export default ConversationPanel;
